import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    MapSelect : false,
    MapFilterSelect : false,
    TableSelect: false,
    TableSelectMarketplace : false,
    TableSelectAlias : false,
    TableSelectVendor : false,
    HeaderProfileSelect : false,
    NotificationModal : false,
    LocationSelect : false,
    MapFilterSelect : false,
}

export const selectSlice = createSlice({
    name : 'select',
    initialState,
    reducers : {
        closeAllSelect : (state) => {
            state.MapSelect = false
            state.MapFilterSelect = false
            state.TableSelect = false
            state.TableSelectMarketplace  = false
            state.TableSelectAlias  = false
            state.TableSelectVendor  = false
            state.TableSortSelectCompetitors = false
            state.HeaderProfileSelect = false
            state.NotificationModal = false
            state.LocationSelect = false
            state.MapFilterSelect = false
        },
        openOrClose : (state, action) => {
            state.MapSelect = false
            state.MapFilterSelect = false
            state.TableSelect = false
            state.TableSelectMarketplace  = false
            state.TableSelectAlias  = false
            state.TableSelectVendor  = false
            state.TableSortSelectCompetitors = false
            state.HeaderProfileSelect = false
            state.NotificationModal = false
            state.LocationSelect = false
            state.MapFilterSelect = false
            state[action.payload] = !state[action.payload]
        },
    }
})

export const {closeAllSelect, openOrClose} = selectSlice.actions
export default selectSlice.reducer